<script>

	import $ from 'jquery'
	import WebinarTable from '@/components/Webinar/WebinarTable'

	export default {
		props: ['webinars'],
		mounted () {
			this.$nextTick(() => {
				const scrollTop = $(window).scrollTop()
				const elTop = $(this.$el).offset().top
				if(scrollTop > elTop) {
					$("html,body").animate({
						scrollTop: elTop
					}, 500, "easeInOutExpo")
				}
			})
		},
		data () {
			return {
				selectedFilter: 'All'
			}
		},
		computed: {
			availableCategories () {
				const set = new Set()
				for(const { category } of this.webinars) {
					if(category) {
						set.add(category)
					}
				}
				return ['All', ...Array.from(set).sort()]
			},
			filteredWebinars () {
				if(this.selectedFilter === 'All') {
					return this.webinars
				}
				return this.webinars.filter(({ category }) => (this.selectedFilter === category))
			}
		},
		methods: {
			setSelectedFilter (filterName) {
				this.selectedFilter = filterName
			}
		},
		render () {
			return (
				<div>
					<ul class="categories">
						{this.availableCategories.map((filterName) => (
							<li class={this.selectedFilter === filterName && 'active'} onClick={() => { this.setSelectedFilter(filterName) }}>
								<div>{filterName}</div>
							</li>
						))}
					</ul>
					{this.filteredWebinars.length ? (
						<WebinarTable webinars={this.filteredWebinars} ref="table" />
					) : (
						<div class="empty">
							<p>There are no Webinars scheduled for this category.</p>
						</div>
					)}
				</div>
			)
		}
	}

</script>

<style lang="scss" scoped>
	.categories {
		display:flex; justify-content: center; align-items: center; margin:16px 0; padding:0; list-style:none; font-size:1.6rem;
		& > li {
			padding:8px 16px; position:relative; font-weight: 600; cursor: pointer;
			&:before {
				position: absolute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				background: #FDB913;
				content: '';
				border-radius: calc(38px / 2);
				transform: scale(0);
				transition: transform 0.15s;
			}
			& > div {
				position:relative; z-index: 1;
			}
		}	
		& > li + li {
			margin-left:12px;
		}
		.active {
			color:#fff;
			&:before {
				transform: scale(1);
			}
		}
	}
	.empty {
		margin:3em 5rem;
	}
</style>



// WEBPACK FOOTER //
// src/routes/webinars/_view-all.vue